/** A thing's avatar in pocket rows (spec §7.1): the shape carries the kind, as on the globe. Monochrome on the standard's
 * variables; a thing a suggestion would create gets the dashed amber ring. */
import type { ThingKind } from "@/api/memory-focus";
import { trayProfileInitials } from "@/desktop/tray-profile-initials";
import { cn } from "@/lib/cn";
import {
  AVATAR_SIZE,
  avatarKindOf,
  thingGlyph,
  type AvatarKind,
} from "@/lib/memory-thing-kinds";
const SHAPE: Record<AvatarKind, string> = {
  you: "rounded-full font-semibold",
  person: "rounded-full font-semibold",
  project: "rounded-[8px] font-semibold",
  app: "rounded-[6px] font-bold",
  topic: "",
  document: "",
};
export function ThingAvatar({
  kind,
  name,
  email,
  pending = false,
}: {
  kind: ThingKind;
  name: string;
  email?: string | null;
  pending?: boolean;
}) {
  const avatar = avatarKindOf(kind);
  const size = AVATAR_SIZE[avatar];
  const lettered = avatar !== "topic" && avatar !== "document";
  return (
    <span
      aria-hidden="true"
      data-avatar-kind={avatar}
      data-pending={pending ? "true" : undefined}
      style={{ width: size, height: size }}
      className={cn(
        "grid flex-none place-items-center text-appkit-small leading-none text-primary",
        SHAPE[avatar],
        lettered && "bg-[var(--color-surface-selected)]",
        pending &&
          "outline-dashed outline-1 outline-offset-2 outline-[var(--color-warning)]",
      )}
    >
      {avatar === "topic" ? (
        <span className="h-2 w-2 rounded-full bg-[var(--color-muted)]" />
      ) : avatar === "document" ? (
        <svg viewBox="0 0 24 24" className="h-full w-full">
          <path
            d="M6.5 3.5h7.5l4 4v13h-11.5z"
            fill="var(--color-surface-selected)"
          />
          <path d="M14 3.5v4h4z" fill="var(--color-subtle)" />
        </svg>
      ) : avatar === "you" ? (
        trayProfileInitials(name, email)
      ) : (
        thingGlyph(name, avatar)
      )}
    </span>
  );
}
